export default __webpack_public_path__ + "static/media/star_full.d6256643.svg";